import { ApplicationStatus, ApplicationType } from 'constants/index';

export const SORT_OPTIONS_CASES = ['highestPriority', 'date', 'applicant', 'loanNumber', 'amount'];
export const SORT_OPTIONS_CONCEPTS = ['date', 'applicant', 'loanNumber', 'amount'];
export const APPLICATION_STATUSES = ['all', ...Object.values(ApplicationStatus)];
export const APPLICATION_TYPES = Object.values(ApplicationType);
